import * as booksCookie from '../../../../../utils/books-step-cookie';

export interface StateOptions {
  seq: number;
  step: number;
  watermark: string;
}

type ControllerType = number | '-1' | '+1';

const findShowStepByWatermarkControl = (
  currentWatermark: string,
  historySeq: number,
  historyStep: number,
  historyWatermark: string,
): ControllerType => {
  const seq = booksCookie.seq();
  const finishedStep = booksCookie.finishedStep();
  if (currentWatermark === '') {
    // 予約フローが完了した直後（リロード前）
    if (seq > historySeq) {
      // 戻る方向: historyStepが1になるまで戻り続ける
      return historyStep === 1 ? 1 : '-1';
    }
    if (seq < historySeq) {
      // 進む方向: finishedStepになるまで進み続ける
      return historyStep === finishedStep! ? finishedStep! : '+1';
    }
    return historyStep === 1 ? 1 : finishedStep!;
  }
  if (currentWatermark !== historyWatermark) {
    // stackのwatermarkと異なるのは以下の2通り
    // 1. 完了後にreload
    // 2. 完了後にstep1までbackした後にreload
    if (seq > historySeq) {
      // 戻る方向: reloadした後はstep1が表示されているので予約フロー前まで戻る
      return '-1';
    }
    if (seq < historySeq) {
      // 進む方向: 何が何でもstep1しか表示しない
      return 1;
    }
    return historyStep === 1 ? 1 : '+1';
  }
  // 予約中
  return historyStep;
};

export const init = () => {
  booksCookie.initialize();
  const state = {
    options: {
      step: 1,
      seq: booksCookie.seq(),
      watermark: booksCookie.watermark(),
    },
  };
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('edge') !== -1) {
    history.pushState(state, document.title, document.URL);
  } else {
    history.replaceState(state, document.title, document.URL);
  }
};

export const setup = (
  options: StateOptions,
): { step: number; renew: boolean } | undefined => {
  const { step, watermark, seq } = options;
  if (!step && !watermark) {
    return undefined;
  }
  const current = booksCookie.watermark();
  const _step = findShowStepByWatermarkControl(current, seq, step, watermark);

  booksCookie.setSeq(seq);
  if (_step === '-1') {
    history.back();
    return undefined;
  }
  if (_step === '+1') {
    history.forward();
    return undefined;
  }
  return { step: _step, renew: !current };
};

export const nextStep = (step: number, completed: boolean): number => {
  const next = step + 1;
  // 同じstepがstackされている場合には載せない。
  if (
    history.state &&
    history.state.options &&
    history.state.options.step !== next
  ) {
    if (next === 2) {
      init();
    }
    if (completed) {
      booksCookie.finalize(next);
    }
    const seq = new Date().getTime();
    booksCookie.setSeq(seq);
    history.pushState(
      { options: { seq, step: next, watermark: booksCookie.watermark() } },
      document.title,
      document.URL,
    );
  }
  return next;
};

export const tick = (callbacks: {
  onForwardCallback: () => void;
  onBackCallback: () => void;
}) => {
  // 状態を維持しつつ、historyを刻みたいだけなので
  // 現時点の最新stateをそのまま上に積む
  history.pushState(
    { ...history.state, tick: true },
    document.title,
    document.URL,
  );
  window.onpopstate = (e) => {
    if (e.state.tick) {
      callbacks.onForwardCallback();
    } else {
      callbacks.onBackCallback();
    }
  };
};

export const back = () => {
  window.onpopstate = null;
  history.back();
};
